export const supportEmail = "mailto:helpdesk@meetfruition.com";
